import type { Question } from './Question';

export class Group {
  public id: string = '';
  public label: string = '';
  public index: number = 0;
  public questions: Question[] = [];
}
